import CloudserviceBanner from './CloudserviceBanner';
export default CloudserviceBanner;
